import { updateObject } from 'utils/updateObject'
import {
  GET_USER_INFO_FETCH_END,
  GET_USER_INFO_FETCH_FAIL,
  GET_USER_INFO_FETCH_START,
  RESET_USER_INFO,
  SET_USER_INFO,
} from './types'

const initialState = {
  loading: false,
  loadFailed: false,
}

const setUserInfo = (state, { payload }) =>
  updateObject(state, {
    ...payload.data,
    loading: false,
    loadFailed: true,
  })

const resetUserInfo = () => ({ ...initialState })

const setLoading = (state) =>
  updateObject(state, {
    loading: true,
    loadFailed: false,
  })

const setLoadingFail = (state) =>
  updateObject(state, {
    loading: false,
    loadFailed: true,
  })

const setLoadingEnd = (state) =>
  updateObject(state, {
    loading: false,
    loaded: true,
    loadFailed: false,
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_INFO:
      return setUserInfo(state, action)
    case GET_USER_INFO_FETCH_START:
      return setLoading(state, action)
    case GET_USER_INFO_FETCH_FAIL:
      return setLoadingFail(state, action)
    case GET_USER_INFO_FETCH_END:
      return setLoadingEnd(state, action)
    case RESET_USER_INFO:
      return resetUserInfo()
    default:
      return state
  }
}

export default reducer
